import type { SuspenseQueryHookOptions } from '@apollo/client';
import {
  type GetInsuranceProviderOptionsQuery,
  type GetInsuranceProviderOptionsQueryVariables,
  useGetInsuranceProviderOptionsSuspenseQuery,
} from 'api/core/generated';
import { AppApiVersions } from 'app-constants';

export const useGetInsuranceProviderOptionsSuspense = (
  options?: SuspenseQueryHookOptions<
    GetInsuranceProviderOptionsQuery,
    GetInsuranceProviderOptionsQueryVariables
  >,
) => {
  const { data, error } = useGetInsuranceProviderOptionsSuspenseQuery({
    context: {
      apiVersion: AppApiVersions.core,
    },
    ...options,
  });

  return {
    insuranceProviderOptions: data?.insurance_provider_options,
    errorLoadingInsuranceProviderOptions: error,
  };
};
